import { useState } from "react";
import ViewVideoPopup from "./ViewVideoPopup";

const ViewVideoCompany = () => {
  const [viewVideo, setViewVideo] = useState<boolean>(false);
  return (
      <div>
        {viewVideo && <ViewVideoPopup close={() => setViewVideo(false)} />}
        <button
          onClick={() => setViewVideo(true)}
          className="bg-red-500 opensans mt-6 text-white px-3 py-1 text-xl rounded-md text-shadow-none w-fit font-light"
        >
          ver video
        </button>
      </div>
  );
};

export default ViewVideoCompany;
